import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackApi } from '@/services/api';

const SESSION_KEY = 'gec_session_id';

function getSessionId(): string {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    trackApi.pageview(getSessionId(), location.pathname);
  }, [location.pathname]);
}
